export const DispensingReadyCalling = {
  Header: {
    DispensingReadyCallingTitle: 'お薬できあがり呼出',
  },
  Message: {
    SelectPharmacy: 'お薬できあがり呼出通知を受け取る薬局をお選びください',
    SelectPharmacyPrecautions:
      '店舗にてスタッフに呼出希望とお声掛けの上、ご利用ください',
  },
};
